import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { WaterCalendarComponent } from './pages/availability/water-calendar.component';
import { CustomerFormComponent } from './pages/customers/customer-form/customer-form.component';
import { CustomerListComponent } from './pages/customers/customer-list/customer-list.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { EmailLogDetailComponent } from './pages/email-logs/email-log-detail/email-log-detail.component';
import { EmailLogListComponent } from './pages/email-logs/email-log-list/email-log-list.component';
import { ExactOnlineComponent } from './pages/exact-online/exact-online.component';
import { LoginComponent } from './pages/login/login.component';
import { PushNotificationsComponent } from './pages/push-notifications/push-notifications.component';
import { ReservationFormComponent } from './pages/reservations/reservation-form/reservation-form.component';
import { ReservationListComponent } from './pages/reservations/reservation-list/reservation-list.component';
import { RootComponent } from './pages/root/root.component';
import { WaterServiceFormComponent } from './pages/water-services/water-services-form/water-service-form.component';
import { WaterServicesListComponent } from './pages/water-services/water-services-list/water-services-list.component';
import { AccommodationFormComponent } from './pages/waters/water-details/accommodations/accommodation-form.component';
import { FishingSpotFormComponent } from './pages/waters/water-details/fishing-spots/fishing-spot-form.component';
import { WaterInformationFormComponent } from './pages/waters/water-details/information/water-information-form.component';
import { WaterPricingComponent } from './pages/waters/water-details/pricing/water-pricing.component';
import { WaterDetailsComponent } from './pages/waters/water-details/water-details.component';
import { WaterListComponent } from './pages/waters/water-list/water-list.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    component: RootComponent,
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'availability',
        component: WaterCalendarComponent,
      },
      {
        path: 'water-services',
        component: WaterServicesListComponent,
      },
      {
        path: 'water-services/:waterId',
        component: WaterServiceFormComponent,
      },
      {
        path: 'push-notifications',
        component: PushNotificationsComponent,
      },
      {
        path: 'exact-online',
        component: ExactOnlineComponent,
      },
      {
        path: 'customers',
        component: CustomerListComponent,
      },
      {
        path: 'customers/create',
        component: CustomerFormComponent,
      },
      {
        path: 'customers/edit/:id',
        component: CustomerFormComponent,
      },
      {
        path: 'reservations',
        component: ReservationListComponent,
      },
      {
        path: 'reservations/create',
        component: ReservationFormComponent,
      },
      {
        path: 'reservations/edit/:id',
        component: ReservationFormComponent,
      },
      {
        path: 'email-logs',
        component: EmailLogListComponent,
      },
      {
        path: 'email-logs/:id',
        component: EmailLogDetailComponent,
      },
      {
        path: 'waters',
        component: WaterListComponent,
      },
      {
        path: 'waters/create',
        component: WaterDetailsComponent,
      },
      {
        path: 'waters/edit/:id',
        component: WaterDetailsComponent,
      },
      {
        path: 'waters/edit/:id/spots/create',
        component: FishingSpotFormComponent,
      },
      {
        path: 'waters/edit/:id/spots/edit/:spotId',
        component: FishingSpotFormComponent,
      },
      {
        path: 'waters/edit/:id/accommodations/create',
        component: AccommodationFormComponent,
      },
      {
        path: 'waters/edit/:id/accommodations/edit/:accommodationId',
        component: AccommodationFormComponent,
      },
      {
        path: 'waters/edit/:id/information',
        component: WaterInformationFormComponent,
      },
      {
        path: 'waters/edit/:id/pricing',
        component: WaterPricingComponent,
      },
    ],
  },
];
